module.exports = __webpack_public_path__ + "05e1bb7407e8368293df113b41047004.png";